export default {
  methods: {
    dispatch(componentName, eventName, params, ...t) {
      let parent = this.$parent || this.$root
      let name = parent.$options.name
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent
        if (parent) {
          name = parent.$options.name
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params, t));
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/ui/src/mixins/emitter.js